import styled from 'styled-components/macro'

import { Overlay } from 'styles/misc'
import { Section as SectionBase } from 'components/misc'
import { TextContainer } from 'components/container'
import { mq } from 'styles/mq'

export const Section = styled(SectionBase)`
  ${TextContainer} {
    position: relative;
  }
`

export const Graphics = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  width: 150vw;
  aspect-ratio: 1140 / 321;
  z-index: -1;

  ${mq.medium} {
    width: 114rem;
  }

  > div {
    ${Overlay}
    opacity: 0.75;
    mask: none center center / contain no-repeat;
    background-color: var(--theme-color);

    &[data-left] {
      mask-image: url("data:image/svg+xml,%3Csvg width='1140' height='321' viewBox='0 0 1140 321' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1140 0H1000.32C1000.29 89.992 927.49 162.933 837.701 162.933C747.911 162.933 675.121 89.992 675.077 0H535.402C535.441 167.318 670.769 302.941 837.701 302.941C1004.63 302.941 1139.96 167.318 1140 0Z'/%3E%3C/svg%3E%0A");
    }

    &[data-right] {
      mask-image: url("data:image/svg+xml,%3Csvg width='1140' height='321' viewBox='0 0 1140 321' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 321H139.675C139.714 231.008 212.51 158.067 302.299 158.067C392.088 158.067 464.879 231.008 464.923 321H604.598C604.554 153.682 469.225 18.0593 302.299 18.0593C135.373 18.0593 0.0387095 153.682 0 321Z' /%3E%3C/svg%3E%0A");
    }
  }
`

export const SmallGraphics = styled.figure<{
  $largeSpacing?: boolean
  $centered?: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 5rem auto;
  max-width: 100%;
  text-align: center;
  @media (min-width: 1024px) {
    flex-direction: row-reverse;
    width: max-content;
    text-align: inherit;
    margin: 15rem auto;
  }
  ${mq.medium} {
    /*flex-direction: row-reverse;
    width: max-content;
    text-align: inherit;
    margin: 15rem auto;*/
  }
`
export const GraphicsImage = styled.img`
  display: block;
`
export const GraphicsDescription = styled.figcaption`
  display: flex;
  flex-direction: column;

  align-items: center;
  gap: 1rem;
  font-size: 1.2rem;
  ${mq.smallOnly} {
    * {
      line-height: 1.5;
    }
  }
  span {
    content: '';
    display: block;
    width: 1.6em;
    height: 1.6em;
    /*margin: 1rem;*/
    border-radius: 50%;
    flex-shrink: 0;
    background-color: var(--theme-color);
  }
  max-width: 46rem;
  @media (min-width: 1024px) {
    max-width: 26rem;
    flex-direction: row;
    &:first-child {
      flex-direction: row-reverse;
    }
    gap: 3rem;
  }
  ${mq.medium} {
    font-size: 1.4rem;
  }
`
